import { Component, OnInit } from '@angular/core';
import { CurriculumConstants } from '../constants/curriculum.contants';
import { TreeNode } from 'primeng/api';
import { TreeData } from '../../shared/models/TreeData';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { AssignmentGroupInteractionService } from '../../system-admin/assignment-group/services/assignment-group-interaction.service';
import { CurriculumService } from '../services/curriculum.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-curriculum-library',
  templateUrl: './curriculum-library.component.html',
  styleUrls: ['./curriculum-library.component.scss']
})
export class CurriculumLibraryComponent implements OnInit{

  constructor(private eqmsScopeManagementService:EqmsScopeManagementService,
    private assignmentGroupInteractionService: AssignmentGroupInteractionService,
    private curriculumService: CurriculumService,  private route: ActivatedRoute) {

  }
  ngOnInit(): void {
    this.isLinkout = this.route.snapshot.queryParamMap.get('isLinkout')!;
    this.curriculumScopeId = this.route.snapshot.queryParamMap.get('scopeId')!;
      this.curriculumService.getCurriculumAuthorization().subscribe({
        next: (serviceData) => {
          this.accessToCurriculum = serviceData;
          this.loadEQMSScope();
        },
        error: (err) => {
          this.accessToCurriculum = false;
          if(err.status === LabelConstants.Forbidden_StatusCode)
            this.curriculumErrorMessage = err.error.detail;
        }
      });
  }

  findNode(node: TreeNode<any>, value : any): TreeNode<any> | null {
    if (node.data.eQMSScopeId === value) {
      this.nodes.push(node);
      return this.nodes[0];
    }
      
    if(node.children != null){
      for (let child of node.children!) {
        let result = this.findNode(child, value);
        if (result) return result;
      }
    }
    return null; // Node not found
  }

  topBarTitle:string =CurriculumConstants.Curriculum_TopBarTitle;
  isCurriculumSliderOpen = false;
  treeSelectPlaceHolderText: string = CurriculumConstants.Scope_Tree_Select_PlaceHolder;
  treeData: TreeNode[] = [];
  selectedScope?: TreeNode;
  ifScopeIsSelected : boolean = false;
  eQMSScopesTreeNode:any;
  accessToCurriculum: boolean = false;
  curriculumErrorMessage!:string;
  nodes : any[] = []
  isLinkout: string = '' ;
  curriculumScopeId : string ='';

  addCurriculum(){
    this.isCurriculumSliderOpen=!this.isCurriculumSliderOpen;
  }

  closeCurriculumSlider(isSliderActive : boolean){
    this.isCurriculumSliderOpen = isSliderActive;
  }

  loadEQMSScope = () => {   
    this.curriculumService.getEQMSScopeForCurriculumManagement().subscribe((eQMSScope) => {
      this.treeData.push(this.createTreeNode(eQMSScope))
      if(this.isLinkout != undefined && this.isLinkout == 'true'){
        this.curriculumService.getCurriculumScopesForUser(this.curriculumScopeId).subscribe(
        {
          next:(scope)=>{
          var node = this.findNode(this.treeData[0], scope);
          if (node) {
            this.selectedScope = node;
          }
          this.checkIfScopeIsSelected();
        },
        error: (err) => {
          this.accessToCurriculum = false;
          if(err.status === LabelConstants.Forbidden_StatusCode)
            this.curriculumErrorMessage = err.error.detail;
        }
      })
      };
    });
  }
  private createTreeNode(node: any): TreeNode {
    const isNodeEnabled = node.isEnable;
 
    return {
      label: node.eQMSScopeName,
      data: node,
      expanded: true,
      selectable: isNodeEnabled,
      children: node.children ? this.createChildNodes(node.children) : undefined,
      style: isNodeEnabled ? 'color: #000000' : 'color: #888'
    };
  }
  
  private createChildNodes(nodes: any[]): TreeNode[] {
    return nodes.map(childNode => this.createTreeNode(childNode));
  }

  checkIfScopeIsSelected(){
    this.ifScopeIsSelected = true;
    this.assignmentGroupInteractionService.updatePanelListOnCreateOrEdit();
  }

  curriculumAccessErrorMessage() : string{
    if (!this.accessToCurriculum) {
      return this.curriculumErrorMessage;
    }
    return CurriculumConstants.Curriculum_UnableToFetchAuth_ErrorMessage;;
  }
}
